module.exports = __webpack_public_path__ + "img/mdi_twitter.0f0c8bfa.png";